export const updateMediaPriceUrl = "/api/v3/org/media_price";
export const getMediaPriceByIdsUrl =
  "/api/v3/org/media_price/collection?ids=:ids";
